// Angular
import { Component, inject, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";

// Services
import { AuthService } from "#services/auth/auth.service";

@Component({
    selector: "app-root",
    imports: [RouterOutlet],
    templateUrl: "./app.component.html",
    styleUrl: "./app.component.scss",
})
export class AppComponent implements OnInit {
    loading = true;

    private authService = inject(AuthService);

    ngOnInit() {
        this.authService.isLoggedIn().then(() => {
            this.loading = false;
        });
    }
}
